/**
 * PRODUCTION-PLANNING MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Public entry point for the production-planning module. The app composition root imports
// ONLY from here; nothing deep-imports this module's internals.
export const productionPlanningRoutes = [

];
